export default "__VITE_ASSET__1d364aad__"